(function () {
  'use strict';

  var PROJECT_ID = 'whn1a4ck1l';
  var STORAGE_KEY = 'az_clarity_attribution_v1';
  var ALLOWED_HOSTS = {
    'weareazourane.com': true,
    'www.weareazourane.com': true,
  };
  var EVENTS = {
    az_product_view: true,
    az_buying_action_visible: true,
    az_add_to_cart_attempt: true,
    az_add_to_cart_success: true,
    az_cart_open: true,
    az_checkout_intent: true,
  };
  var FREE_SAMPLE_VARIANT_IDS = {
    '53792738509107': true,
    '53716614283571': true,
    '53716614316339': true,
  };
  var CHECKOUT_SELECTOR = [
    'a[href*="/checkout"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[data-az-buy-now]',
    '.az-buy-now-btn',
    '[data-azmc-checkout]',
  ].join(',');
  var BUYING_ACTION_SELECTOR = [
    'form[action*="/cart/add"] [type="submit"]',
    'product-form [type="submit"]',
    '.product-form__submit',
    '[data-az-buy-now]',
    '.az-buy-now-btn',
  ].join(',');

  var host = String((window.location && window.location.hostname) || '').toLowerCase();
  if (!ALLOWED_HOSTS[host]) return;
  if (window.__azClarityFunnel20260804Loaded) return;

  function hasExpectedProjectLoader() {
    var scripts = document.getElementsByTagName('script');
    var needle = 'clarity.ms/tag/' + PROJECT_ID;
    for (var index = 0; index < scripts.length; index += 1) {
      var source = scripts[index].getAttribute('src') || '';
      if (source.indexOf(needle) !== -1) return true;
    }
    return false;
  }

  // Fail closed if this asset is ever copied outside the AZOURANE Clarity project.
  if (!hasExpectedProjectLoader()) return;
  window.__azClarityFunnel20260804Loaded = true;

  function clarityCall() {
    if (typeof window.clarity !== 'function') return false;
    try {
      window.clarity.apply(window, arguments);
      return true;
    } catch (_) {
      return false;
    }
  }

  function emitEvent(name) {
    if (!EVENTS[name]) return;
    clarityCall('event', name);
  }

  var ALLOWED_UTM_SOURCES = {
    meta: true,
    facebook: true,
    fb: true,
    instagram: true,
    ig: true,
    google: true,
    bing: true,
    tiktok: true,
    linkedin: true,
    email: true,
    newsletter: true,
    whatsapp: true,
    viber: true,
    shopify: true,
    product_label: true,
    chatgpt_com: true,
    direct: true,
  };
  var ALLOWED_UTM_MEDIA = {
    paid_social: true,
    paid: true,
    cpc: true,
    ppc: true,
    social: true,
    organic: true,
    email: true,
    referral: true,
    display: true,
    retargeting: true,
    affiliate: true,
    sms: true,
    qr: true,
  };

  function sanitizeAllowlistedToken(value, allowed) {
    if (typeof value !== 'string') return '';
    var clean = value.trim().toLowerCase().replace(/[ .~-]+/g, '_');
    return allowed[clean] ? clean : '';
  }

  function sanitizeSource(value) {
    return sanitizeAllowlistedToken(value, ALLOWED_UTM_SOURCES);
  }

  function sanitizeMedium(value) {
    return sanitizeAllowlistedToken(value, ALLOWED_UTM_MEDIA);
  }

  function sanitizeNumericId(value) {
    var clean = String(value == null ? '' : value).trim();
    return /^\d{1,32}$/.test(clean) ? clean : '';
  }

  function sanitizePresence(value) {
    return value === '1' || value === 1 || value === true ? '1' : '';
  }

  var ATTRIBUTION_RULES = {
    utm_source: sanitizeSource,
    utm_medium: sanitizeMedium,
    campaign_id: sanitizeNumericId,
    ad_id: sanitizeNumericId,
    fbclid_present: sanitizePresence,
    gclid_present: sanitizePresence,
  };
  var CLARITY_TAGS = {
    utm_source: 'az_utm_source',
    utm_medium: 'az_utm_medium',
    campaign_id: 'az_campaign_id',
    ad_id: 'az_ad_id',
    fbclid_present: 'az_fbclid_present',
    gclid_present: 'az_gclid_present',
  };

  function sanitizeAttributionObject(value) {
    var safe = {};
    if (!value || typeof value !== 'object' || Array.isArray(value)) return safe;
    Object.keys(ATTRIBUTION_RULES).forEach(function (key) {
      var clean = ATTRIBUTION_RULES[key](value[key]);
      if (clean) safe[key] = clean;
    });
    return safe;
  }

  function readStoredAttribution() {
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
      return sanitizeAttributionObject(parsed);
    } catch (_) {
      return {};
    }
  }

  function readCurrentAttribution() {
    var current = {};
    var params;
    try {
      params = new URLSearchParams((window.location && window.location.search) || '');
    } catch (_) {
      return current;
    }

    var source = sanitizeSource(params.get('utm_source') || '');
    var medium = sanitizeMedium(params.get('utm_medium') || '');
    if (source) current.utm_source = source;
    if (medium) current.utm_medium = medium;

    var campaignId = sanitizeNumericId(
      params.get('campaign_id') || params.get('campaignid') || params.get('utm_id') || ''
    );
    var adId = sanitizeNumericId(
      params.get('ad_id') || params.get('adid') || params.get('creative_id') || ''
    );
    if (campaignId) current.campaign_id = campaignId;
    if (adId) current.ad_id = adId;
    // Click IDs are deliberately never read. Only their presence is retained.
    if (params.has('fbclid')) current.fbclid_present = '1';
    if (params.has('gclid')) current.gclid_present = '1';
    return current;
  }

  function applySafeAttribution() {
    var current = readCurrentAttribution();
    // Explicit last-touch semantics: a new recognized campaign replaces the
    // complete prior record, so fields from separate visits can never mix.
    var combined = Object.keys(current).length
      ? sanitizeAttributionObject(current)
      : readStoredAttribution();

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(combined));
    } catch (_) {}

    Object.keys(combined).sort().forEach(function (key) {
      clarityCall('set', CLARITY_TAGS[key], combined[key]);
    });
  }

  function cartAddPath(value) {
    var raw = '';
    if (typeof value === 'string') raw = value;
    else if (value && typeof value.url === 'string') raw = value.url;
    if (!raw) return false;
    try {
      var pathname = new URL(raw, window.location.origin).pathname.toLowerCase();
      return /\/cart\/add(?:\.js)?\/?$/.test(pathname);
    } catch (_) {
      var pathOnly = String(raw).split(/[?#]/)[0].toLowerCase();
      return /\/cart\/add(?:\.js)?\/?$/.test(pathOnly);
    }
  }

  function requestIsPost(input, options) {
    var method = (options && options.method) || (input && input.method) || 'GET';
    return String(method).toUpperCase() === 'POST';
  }

  function valueIsFreeSampleId(value) {
    return !!FREE_SAMPLE_VARIANT_IDS[sanitizeNumericId(value)];
  }

  function automaticGiftFromObject(payload) {
    if (!payload || typeof payload !== 'object') return false;
    var rows = Array.isArray(payload.items) ? payload.items : [payload];
    if (!rows.length) return false;
    return rows.every(function (row) {
      if (!row || typeof row !== 'object') return false;
      var properties = row.properties || {};
      return String(properties._az_auto_gift || '') === '1' || valueIsFreeSampleId(row.id);
    });
  }

  function automaticGiftFromParams(params) {
    var autoGift = false;
    var ids = [];
    try {
      params.forEach(function (value, key) {
        var name = String(key);
        if (name.indexOf('_az_auto_gift') !== -1 && String(value) === '1') autoGift = true;
        if (name === 'id' || /items\[\d+\]\[id\]$/.test(name)) ids.push(value);
      });
    } catch (_) {
      return false;
    }
    if (ids.length && ids.every(valueIsFreeSampleId)) return true;
    return autoGift && (!ids.length || ids.every(valueIsFreeSampleId));
  }

  function isAutomaticFreeSampleBody(body) {
    if (!body) return false;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return automaticGiftFromParams(body);
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return automaticGiftFromParams(body);
    }
    if (typeof body === 'string') {
      if (body.length > 16384) return false;
      try {
        if (automaticGiftFromObject(JSON.parse(body))) return true;
      } catch (_) {}
      try {
        return automaticGiftFromParams(new URLSearchParams(body));
      } catch (_) {
        return false;
      }
    }
    return automaticGiftFromObject(body);
  }

  var lastAttemptAt = 0;
  var lastCheckoutIntentAt = 0;

  function now() {
    return Date.now();
  }

  function emitAttempt() {
    var timestamp = now();
    if (timestamp - lastAttemptAt < 300) return;
    lastAttemptAt = timestamp;
    emitEvent('az_add_to_cart_attempt');
  }

  function emitCheckoutIntent() {
    var timestamp = now();
    if (timestamp - lastCheckoutIntentAt < 500) return;
    lastCheckoutIntentAt = timestamp;
    emitEvent('az_checkout_intent');
  }

  function observeFetch() {
    if (typeof window.fetch !== 'function') return;
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var options = arguments[1] || {};
      var track = cartAddPath(input) && requestIsPost(input, options) && !isAutomaticFreeSampleBody(options.body);
      if (track) emitAttempt();

      var result;
      try {
        result = nativeFetch.apply(this, arguments);
      } catch (error) {
        throw error;
      }

      // The live cart deliberately falls back to a native form submission when
      // its AJAX leg fails. Only a confirmed 2xx response is final here; a
      // rejected AJAX leg is not mislabeled as a failed add-to-cart.
      if (track && result && typeof result.then === 'function') {
        result.then(
          function (response) {
            if (response && response.ok) emitEvent('az_add_to_cart_success');
          },
          function () {}
        );
      }
      // Return the original Promise and original Response object untouched.
      return result;
    };
  }

  function observeXhr() {
    if (typeof window.XMLHttpRequest !== 'function') return;
    var proto = window.XMLHttpRequest.prototype;
    if (!proto || typeof proto.open !== 'function' || typeof proto.send !== 'function') return;
    var nativeOpen = proto.open;
    var nativeSend = proto.send;

    proto.open = function (method, url) {
      this.__azClarityCartAdd = String(method || '').toUpperCase() === 'POST' && cartAddPath(url);
      return nativeOpen.apply(this, arguments);
    };

    proto.send = function (body) {
      var request = this;
      var track = !!request.__azClarityCartAdd && !isAutomaticFreeSampleBody(body);
      var finished = false;

      function finish() {
        if (!track || finished) return;
        finished = true;
        if (request.status >= 200 && request.status < 300) {
          emitEvent('az_add_to_cart_success');
        }
      }

      if (track) {
        emitAttempt();
        if (typeof request.addEventListener === 'function') {
          request.addEventListener('loadend', finish, { once: true });
        }
      }

      try {
        return nativeSend.apply(request, arguments);
      } catch (error) {
        throw error;
      }
    };
  }

  function closestElement(target, selector) {
    return target && typeof target.closest === 'function' ? target.closest(selector) : null;
  }

  function formIsCartAdd(form) {
    if (!form || typeof form.getAttribute !== 'function') return false;
    var action = form.getAttribute('action') || form.action || '';
    var method = form.getAttribute('method') || form.method || 'GET';
    return cartAddPath(action) && String(method).toUpperCase() === 'POST';
  }

  function observeDocumentIntents() {
    document.addEventListener('click', function (event) {
      if (closestElement(event.target, CHECKOUT_SELECTOR)) emitCheckoutIntent();
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      var submitter = event.submitter;
      if (formIsCartAdd(form)) {
        var body = null;
        try {
          body = new FormData(form);
        } catch (_) {}
        if (!isAutomaticFreeSampleBody(body)) emitAttempt();
      }

      var checkoutForm = form && typeof form.getAttribute === 'function'
        && cartAddPath(form.getAttribute('action') || form.action || '') === false
        && String(form.getAttribute('action') || form.action || '').indexOf('/checkout') !== -1;
      var checkoutSubmitter = closestElement(submitter, CHECKOUT_SELECTOR);
      if (checkoutForm || checkoutSubmitter) emitCheckoutIntent();
    }, true);
  }

  function isProductPage() {
    return !!document.querySelector('main[data-template="product"]');
  }

  function buyingActionIsUsable(element) {
    if (!element || !document.documentElement.contains(element)) return false;
    if (closestElement(element, '#AZMiniCart')) return false;
    if (element.disabled || element.getAttribute('aria-disabled') === 'true') return false;
    return true;
  }

  function observeBuyingActionVisibility() {
    if (!isProductPage()) return;
    var sent = false;
    var observer = null;
    var discoveryObserver = null;

    function send() {
      if (sent) return;
      sent = true;
      emitEvent('az_buying_action_visible');
      if (observer) observer.disconnect();
      if (discoveryObserver) discoveryObserver.disconnect();
    }

    function visibleWithoutObserver(element) {
      if (!buyingActionIsUsable(element) || typeof element.getBoundingClientRect !== 'function') return false;
      var rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0
        && rect.top < (window.innerHeight || document.documentElement.clientHeight)
        && rect.left < (window.innerWidth || document.documentElement.clientWidth);
    }

    function bind() {
      if (sent) return true;
      var controls = Array.prototype.filter.call(
        document.querySelectorAll(BUYING_ACTION_SELECTOR),
        buyingActionIsUsable
      );
      if (!controls.length) return false;

      if (typeof window.IntersectionObserver === 'function') {
        observer = new window.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!sent && entry.isIntersecting && entry.intersectionRatio > 0 && buyingActionIsUsable(entry.target)) {
              send();
            }
          });
        }, { threshold: 0.01 });
        controls.forEach(function (control) { observer.observe(control); });
      } else if (controls.some(visibleWithoutObserver)) {
        send();
      }
      return true;
    }

    if (!bind() && typeof window.MutationObserver === 'function') {
      discoveryObserver = new window.MutationObserver(function () {
        if (bind() && discoveryObserver) discoveryObserver.disconnect();
      });
      discoveryObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function observeCartOpen() {
    var cart = document.getElementById('AZMiniCart');
    if (!cart || typeof window.MutationObserver !== 'function') return;
    var wasOpen = cart.classList.contains('is-open') && cart.getAttribute('aria-hidden') !== 'true';
    var observer = new window.MutationObserver(function () {
      var isOpen = cart.classList.contains('is-open') && cart.getAttribute('aria-hidden') !== 'true';
      if (isOpen && !wasOpen) emitEvent('az_cart_open');
      wasOpen = isOpen;
    });
    observer.observe(cart, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
  }

  function onDomReady() {
    if (isProductPage()) emitEvent('az_product_view');
    observeBuyingActionVisibility();
    observeCartOpen();
  }

  applySafeAttribution();
  observeFetch();
  observeXhr();
  observeDocumentIntents();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDomReady, { once: true });
  } else {
    onDomReady();
  }
})();
